import { Select } from "antd";
import { SelectProps } from "antd/lib/select";
import { UserType as UserTypeEnum } from "components/CurrentUser/constants";
import UserType from "pages/Account/pages/UserManagement/pages/User/components/UserType";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props extends SelectProps<UserTypeEnum> {
  allVisible?: boolean;
}

const UserTypeSelect: React.FC<Props> = (props) => {
  const { allVisible, ...rest } = props;
  const { t } = useTranslation();
  return (
    <Select
      placeholder={t("account.user_management.user.select_type")}
      {...rest}
    >
      <Select.Option value={UserTypeEnum.SELLER}>
        <UserType type={UserTypeEnum.SELLER} />
      </Select.Option>
      <Select.Option value={UserTypeEnum.KOL}>
        <UserType type={UserTypeEnum.KOL} />
      </Select.Option>
      <Select.Option value={UserTypeEnum.AFFILIATOR}>
        <UserType type={UserTypeEnum.AFFILIATOR} />
      </Select.Option>
      <Select.Option value={UserTypeEnum.PARTNER}>
        <UserType type={UserTypeEnum.PARTNER} />
      </Select.Option>
      <Select.Option value={UserTypeEnum.OPERATOR}>
        <UserType type={UserTypeEnum.OPERATOR} />
      </Select.Option>
      {allVisible && (
        <Select.Option value={UserTypeEnum.ALL}>
          <UserType type={UserTypeEnum.ALL} />
        </Select.Option>
      )}
    </Select>
  );
};

export default UserTypeSelect;
